import config from '@/services/config'
import axios from 'axios'

const servicioBase = axios.create(
    {
        baseURL: config.apiUrl
    })
    servicioBase.interceptors.request.use (
        config => {
                const accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpUGF0JCRwYSZzIiwiaWQiOiIxIiwidXNlciI6ImlQYXQkJHBhJnMiLCJuYW1lIjoiMCV0b2tvbiQkIiwianRpIjoiNWU0OWI4NjUtYzZlNS00MTA0LWFhOTUtOTNkYjAxMmJjNTMwIiwiaWF0IjoxNzc1ODMxNzc0LCJleHAiOjE4MDY5NjA5NzQsIm5iZiI6MTc3NTg1Njk3NCwiaXNzIjoiaHR0cDovL3d3dy53YXJtcGFjay5jb20iLCJhdWQiOiJQYWdpbmEgd2ViIn0.90Cwo_gCnAFNqLku7lC5KOyJO8kyC_5rTNvpM5R3Dsg'
                config.headers.Authorization = `Bearer ${ accessToken }`
                return config
            
        }
    )
    export default servicioBase;